export default __webpack_public_path__ + "static/media/11.3e60f28f.png";